const Data = [
  {
    id: 1,
    title: "Rosyjscy żołnierze oskarżani o grabieże",
    desc: "Hajun napisał, że 'obok oddziału rosyjskiej firmy kurierskiej CDEK w Mozyrzu widziano kamazy (ciężarówki) rosyjskich sił zbrojnych, z których żołnierze wypakowywali owinięte toboły'. 2 kwietnia informowano o ich nadawaniu w punkcie, co ustalono na podstawie nagrań z kamery internetowej.",
    cover: "./assets/work/6.png",
  },
  {
    id: 2,
    title: "Putin może zostać uznany zbrodniarzem wojennym i ludobójcą",
    desc: "Prezydentowi Rosji zarzuca się nie tylko rozpętanie nieuzasadnionej wojny, ale też łamanie wszelkich międzynarodowych praw. Jego armia ostrzeliwuje domy mieszkalne, szkoły i szpitale, żołnierze rosyjscy z premedytacją mordują cywilów, gwałcą Ukrainki i plądrują domy oraz sklepy. Z mieszkańców miast i miejscowości tworzą żywe tarcze. Nie oszczędzają nawet zupełnie niewinnych dzieci ...",
    cover: "./assets/work/1.png",
  },
  {
    id: 3,
    title: "Festiwal rosyjskiej niekompetencji trwa",
    desc: "Na południe od Białej Cerkwi nastąpiła wymiana ognia między dwiema kolumnami rosyjskich wojsk. Choć takim przypadkom miały zapobiegać znaki szybkiej identyfikacji na rosyjskich pojazdach, w tym wypadku coś poszło nie tak. – 'Dziękujemy za oszczędzenie nam 13 Javelinów!' – piszą Ukraińcy w mediach społecznościowych.",
    cover: "./assets/work/2.png",
  },
  {
    id: 4,
    title: "Wojskowy teatrzyk Putina",
    desc: "W obliczu wrześniowych wyborów parlamentarnych (w Rosji) Putin mógł zdecydować, że konieczny jest jakiś wojskowy teatrzyk, by odwrócić uwagę Rosjan od stagnacji gospodarczej i po raz kolejny obsadzić się w roli niezastąpionego obrońcy narodu.",
    cover: "./assets/work/3.png",
  },
  {
    id: 5,
    title: "Daj coś z worka dla Orka",
    desc: "Pod ambasadą Rosji w Londynie Brytyjczycy zostawiali m.in. garnki, patelnie, suszarki do włosów, trampki, ubrania, a nawet pralkę. Wszystkie stare i zniszczone. Manifestujący oblali przedmioty czerwoną farbą, która miała symbolizować krew zabitych Ukraińców. Chcieli w ten sposób nawiązać do licznych grabieży dokonywanych przez rosyjskich żołnierzy na okupowanych przez nich terenach.",
    cover: "./assets/work/8.png",
  },
  {
    id: 6,
    title: "Putin szantażuje Europę i każe płacić za gaz w rublach",
    desc: "Zachód przekonuje, że szantażowi — jak interpretuje dekret Putina — nie ulegnie. Państwa zasiadające w radzie G7 jednogłośnie zapowiedziały, że w rublach płacić nie zamierzają. Niemiecki minister gospodarki Robert Habeck dodał, że zawarte umowy są w mocy, a zaangażowane w nie przedsiębiorstwa dochowają wierności umowom.",
    cover: "./assets/work/7.png",
  },
];

export default Data;
